import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { Workspace } from '@/hooks/api/models';

/**
 * 0320. チームメンバー削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/team_members/:team_member_id
 */
type Props = {
  identifier: string;
  team_id: number;
  team_member_id: number;
};
export const destroyTeamMember = (props: Props): Promise<any> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/team_members/${props.team_member_id}`
  );
};

export const useDestroyTeamMember = () => {
  return useMutation({
    mutationFn: destroyTeamMember,
  });
};
